import 'date-fns';
import React from 'react';
import styled from 'styled-components';
import DateFnsUtils from '@date-io/date-fns';
import {MuiPickersUtilsProvider, KeyboardDatePicker} from '@material-ui/pickers';
import SGBody from 'components/Typography/SGBody';
import DateRangeIcon from '@material-ui/icons/DateRange';
import InsightsPickersThemeProvider from 'components/MUI/InsightsPickersThemeProvider';

interface DateSelectorProps {
  selectedDate: Date | null;
  setSelectedDate: (value: Date | null) => void;
}

const StyledUtilsProvider = styled(MuiPickersUtilsProvider)`
  margin-top: 8px;
`;

const StyledDatePickerContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StyledDatePicker = styled(KeyboardDatePicker)`
  &.MuiFormControl-marginNormal {
    margin-top: 8px;
  }
  &.MuiFormControl-marginNormal {
    margin-top: none;
    margin-bottom: none;
  }
  .MuiPickersBasePicker-pickerView {
    background-color: ${props => props.theme.cardBg};
  }
  .MuiInputAdornment-positionEnd {
    margin-left: 0;
  }
  label {
    display: none;
  }
  input {
    opacity: 0;
    width: 0px;
    padding: 0px;
    pointer-events: none;
    visibility: hidden;
  }
  .MuiInputBase-root {
    margin-top: 0;
  }
  .MuiInput-underline:before {
    border-bottom: none;
    content: unset;
  }
  .MuiIconButton-root {
    color: ${props => props.theme.disabledStateBlue};
    &:hover {
      color: ${props => props.theme.activeStateBlue};
    }
  }
`;

function DateSelector({selectedDate, setSelectedDate}: DateSelectorProps) {
  const dateValue = selectedDate ? selectedDate : new Date(new Date());

  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
  };

  return (
    <InsightsPickersThemeProvider>
      <StyledDatePickerContainer>
        <StyledUtilsProvider utils={DateFnsUtils}>
          <StyledDatePicker
            disableToolbar
            disableFuture
            minDate={'2023-05-01T19:30:00.000Z'}
            variant="inline"
            format="MM/dd/yyyy"
            margin="normal"
            id="rrp-date-picker-inline"
            label="Date picker inline"
            value={dateValue}
            onChange={handleDateChange}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            keyboardIcon={<DateRangeIcon />}
          />
        </StyledUtilsProvider>
        <SGBody>View 30-day reports</SGBody>
      </StyledDatePickerContainer>
    </InsightsPickersThemeProvider>
  );
}

export default DateSelector;
